import React, { useState } from 'react';
import { Alert, Dropdown, Table } from 'react-bootstrap';
import {
    GetJobLogMetaData,
    GetJobLogMetaData_getJobLogMetaData_types as JobLogTypesType,
    GetJobLogMetaData_getJobLogMetaData_issues as JobLogIssueType,
    GetJobLogMetaData_getJobLogMetaData_rootcauses as JobLogRootCauseType,
    GetJobLogMetaData_getJobLogMetaData_locationLOFAs as JobLogLocationLofaType,
    GetJobLogs,
    GetJobLogs_getJobLogs_details as JobLogDetailsType,
    StopJobLog,
    DeleteJobLog,
} from '../../../types/schemaTypes';
import { GET_JOB_LOGS, GET_JOB_LOG_META_DATA } from '../../../graphql/client/queries';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useQuery, useMutation, useLazyQuery } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { DateTimePicker, Error, Loading } from '../../_common';
import JobLogDetailsItem from './JobLogDetailsItem';

import { Parser } from '@json2csv/plainjs';
import { ADD_EDIT_JOB_LOGS, DELETE_JOB_LOG, STOP_JOB_LOG } from '../../../graphql/client/mutations';

import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../utils/helpers/toastHelper'
import AddEditJobLogModal from './JobLogModals/AddEditJobLogModal';
import JobLogStageModal from './JobLogModals/JobLogStageModal';

const JobLogDetails = ({ jobId }): React.ReactElement => {
    const authContext = useAuthContext();
    const isAddJobLogsEnabled = authContext.userHasPermission(PermissionEnum.AddJobLogs);

    const [pageNum, setPageNum] = useState(1);

    const [jobLogTypeId, setJobLogTypeId] = useState(-1);
    const [jobLogType, setJobLogType] = useState('Job Log Type');
    const [jobLogId, setJobLogId] = useState(-1);

    const [openFromCalender, setOpenFromCalender] = useState(true);
    const [openToCalender, setOpenToCalender] = useState(false);
    const [clearFromDate, setClearFromDate] = useState(true);
    const [clearToDate, setClearToDate] = useState(true);
    const [tempDate, setTempDate] = useState<any>();
    const [dateError, setDateError] = useState('');

    const [isDownload, setIsDownload] = useState<boolean>(false);

    const [jobLogToEdit, setJobLogToEdit] = useState<JobLogDetailsType>();
    const [showAddEditJobLogModal, setShowAddEditJobLogModal] = useState(false);
    const [showJobLogStageModal, setShowJobLogStageModal] = useState(false);
    const [modalError, setModalError] = useState('');
    const [isStartStage, setIsStartStage] = useState(false);
    const toasterOptions = { duration: 4500 };
    const Messages = {
        stopLog: 'Job Log resolved successfully',
        deleteLog: 'Job Log deleted successfully',
        editLog: 'Job Log updated successfully',
        addLog: 'Job Log added successfully',
    };
    const ErrorMessages = {
        stopLog: 'Failed to stop the Log',
        deleteLog: 'Failed to delete the Log',
        editLog: 'Failed to edit the Log',
        addLog: 'Failed to add Log',
    };
    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };

        Comp.displayName = 'toast';
        return Comp;
    };

    const today = new Date();
    const [toDate, setToDate] = useState(
        `${today.getFullYear()}-${today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1}-${today.getDate() < 10 ? `0${today.getDate()}` : today.getDate()
        }`,
    );

    const tempFromDate = new Date();
    tempFromDate.setDate(today.getDate() - 13);

    const [fromDate, setFromDate] = useState(
        `${tempFromDate.getFullYear()}-${tempFromDate.getMonth() + 1 < 10 ? `0${tempFromDate.getMonth() + 1}` : tempFromDate.getMonth() + 1
        }-${tempFromDate.getDate() < 10 ? `0${tempFromDate.getDate()}` : tempFromDate.getDate()}`,
    );

    const { loading: jobLogsMetaDataLoading, error: jobLogsMetaDataError, data: jobLogsMetaData } = useQuery<
        GetJobLogMetaData
    >(GET_JOB_LOG_META_DATA, {
        variables: {
            jobId: jobId,
        },
        fetchPolicy: 'network-only',
    });
    const jobLogsTypesData: JobLogTypesType[] = [];
    const jobLogsIssuesData: JobLogIssueType[] = [];
    const jobLogsRootCausesData: JobLogRootCauseType[] = [];
    const jobLogsLocationLofaData: JobLogLocationLofaType[] = [];
    if (jobLogsMetaData && jobLogsMetaData.getJobLogMetaData) {
        if (jobLogsMetaData.getJobLogMetaData.types)
            jobLogsMetaData.getJobLogMetaData.types.map(jobLogType => {
                if (jobLogType) jobLogsTypesData.push(jobLogType);
            });
        if (jobLogsMetaData.getJobLogMetaData.issues)
            jobLogsMetaData.getJobLogMetaData.issues.map(jobLogIssue => {
                if (jobLogIssue) jobLogsIssuesData.push(jobLogIssue);
            });
        if (jobLogsMetaData.getJobLogMetaData.rootcauses)
            jobLogsMetaData.getJobLogMetaData.rootcauses.map(jobLogRootCauses => {
                if (jobLogRootCauses) jobLogsRootCausesData.push(jobLogRootCauses);
            });
        if (jobLogsMetaData.getJobLogMetaData.locationLOFAs)
            jobLogsMetaData.getJobLogMetaData.locationLOFAs.map(jobLogLocationLofa => {
                if (jobLogLocationLofa) jobLogsLocationLofaData.push(jobLogLocationLofa);
            });
    }

    const downloadHandler = jobLogsForDownload => {
        if (
            jobLogsForDownload &&
            jobLogsForDownload.getJobLogs &&
            jobLogsForDownload.getJobLogs.details &&
            isDownload
        ) {
            if (jobLogsForDownload.getJobLogs.details.length === 0) {
                setIsDownload(false);
                return;
            }
            const data = jobLogsForDownload.getJobLogs.details.map(jobLogDetail => {
                return {
                    ID: jobLogDetail?.id,
                    'Log Type': jobLogDetail?.jobLogType,
                    Issue: jobLogDetail?.jobLogIssue,
                    Notes: jobLogDetail?.allNotes,
                    'Start Date Time': jobLogDetail?.startDate,
                    'End Date Time': jobLogDetail?.endDate,
                    Duration: jobLogDetail.duration,
                    'Created On': jobLogDetail?.dateCreated,
                    'Created By': jobLogDetail?.createdBy,
                    Status: jobLogDetail?.status,
                    'Amount (in lbs)': jobLogDetail?.amount,
                    'Well Name': jobLogDetail?.wellName,
                    'Estimated Downtime (in minutes)': jobLogDetail?.estimatedDowntime,
                    'Load ID': jobLogDetail?.loadId,
                    LOFA: jobLogDetail?.locationLofa,
                    'Root Cause': jobLogDetail?.rootCause,
                    'Corrective Action': jobLogDetail?.correctiveAction,
                    Stage: jobLogDetail?.stage,
                    'Overall Stage': jobLogDetail?.overallStage,
                    'Total Volume Pumped':
                        jobLogDetail?.jobLogIssue === 'Start Stage' ? '' : jobLogDetail?.totalSandPumped,
                };
            });

            //const csvData = parse(data);
            const opts = {};
            const parser = new Parser(opts);
            const csvData = parser.parse(data);
            const file = new Blob([csvData], { type: 'application/csv' });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = `JobLogs.csv`;
            a.click();
            setIsDownload(false);
        }
    };
    const [downloadJobLogs, { data: jobLogsForDownload, loading: jobLogsForDownloadLoading }] = useLazyQuery<GetJobLogs>(
        GET_JOB_LOGS,
        { fetchPolicy: 'network-only' },
    );

    React.useEffect(() => {
        if (!jobLogsForDownloadLoading && jobLogsForDownload && isDownload) {
            downloadHandler(jobLogsForDownload);
        }
    }, [jobLogsForDownloadLoading, jobLogsForDownload, isDownload]);

    const { loading: jobLogsLoading, error: jobLogsError, data: jobLogsData, previousData } = useQuery<GetJobLogs>(GET_JOB_LOGS, {
        variables: {
            input: {
                jobId: jobId,
                jobLogTypeId: jobLogTypeId,
                jobLogId: jobLogId,
                fromDate: fromDate,
                toDate: toDate,
                pageNum: pageNum,
                tzinfo: new Date()
                    .toString()
                    .split('(')[1]
                    .replace(')', ''),
            },
        },
        fetchPolicy: 'network-only',
    });
    const jobLogsDetails: JobLogDetailsType[] = [];
    let isLastItem = true;
    
    if (!jobLogsData && previousData) {

        if (previousData && previousData.getJobLogs && previousData.getJobLogs.details) {
            previousData.getJobLogs.details.map(jobLogDetail => {
                if (jobLogDetail) jobLogsDetails.push(jobLogDetail);
            });
            isLastItem = previousData.getJobLogs.isLastPage ?? true;
        }
    } else {
        if (jobLogsData && jobLogsData.getJobLogs && jobLogsData.getJobLogs.details) {
            jobLogsData.getJobLogs.details.map(jobLogDetail => {
                if (jobLogDetail) jobLogsDetails.push(jobLogDetail);
            });
            isLastItem = jobLogsData.getJobLogs.isLastPage ?? true;
        }
    }
    
    const [stopJobLog, { loading: stopJobLogLoading, error: stopJobLogError }] = useMutation<StopJobLog>(STOP_JOB_LOG, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                const serverErrorWithComa = error.errors[0]?.message?.toString().replace(',', ' ') || error.message;
                const errorMessage = serverErrorWithComa.split('|');
                toast.error(`${ErrorMessages['stopLog']} ${errorMessage}`, toastOpt);

            } else {
                toast.error(`${ErrorMessages['stopLog']} ${error.message ?? error}`, toastOpt);

            }
        },
        onCompleted: () => toast.success(Messages['stopLog'], toastOpt),
        refetchQueries: [
            {
                query: GET_JOB_LOG_META_DATA,
                variables: {
                    jobId: jobId,
                },
            },
            {
                query: GET_JOB_LOGS,
                variables: {
                    input: {
                        jobId: jobId,
                        jobLogTypeId: jobLogTypeId,
                        jobLogId: jobLogId,
                        fromDate: fromDate,
                        toDate: toDate,
                        pageNum: pageNum,
                        tzinfo: new Date()
                            .toString()
                            .split('(')[1]
                            .replace(')', ''),
                    },
                },
            },
        ],
    });

    const [deleteJobLog, { loading: deleteJobLogLoading, error: deleteJobLogError }] = useMutation<DeleteJobLog>(
        DELETE_JOB_LOG,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    const serverErrorWithComa = error.errors[0]?.message?.toString().replace(',', ' ') || error.message;
                    const errorMessage = serverErrorWithComa.split('|');
                    toast.error(`${ErrorMessages['deleteLog']} ${errorMessage}`, toastOpt);

                } else {
                    toast.error(`${ErrorMessages['deleteLog']} ${error.message ?? error}`, toastOpt);

                }
            },
            onCompleted: () => toast.success(Messages['deleteLog'], toastOpt),
            refetchQueries: [
                {
                    query: GET_JOB_LOG_META_DATA,
                    variables: {
                        jobId: jobId,
                    },
                },
                {
                    query: GET_JOB_LOGS,
                    variables: {
                        input: {
                            jobId: jobId,
                            jobLogTypeId: jobLogTypeId,
                            jobLogId: jobLogId,
                            fromDate: fromDate,
                            toDate: toDate,
                            pageNum: pageNum,
                            tzinfo: new Date()
                                .toString()
                                .split('(')[1]
                                .replace(')', ''),
                        },
                    },
                },
            ],
        },
    );

    const handleOnStopLog = jobLogId => {
        stopJobLog({
            variables: {
                input: {
                    jobLogId: jobLogId,
                },
            },
        });
    };

    const handleOnDeleteLog = jobLogId => {
        deleteJobLog({
            variables: {
                input: {
                    jobLogId: jobLogId,
                },
            },
        });
    };

    const [addEditJobLog, { loading: addEditJobLogLoading }] = useMutation(ADD_EDIT_JOB_LOGS, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                const serverErrorWithComa = error.errors[0]?.message?.toString().replace(',', ' ') || error.message;
                const errorMessage = serverErrorWithComa.split('|');
                if (jobLogToEdit)
                    toast.error(`${ErrorMessages['editLog']} ${errorMessage}`, toastOpt);

                else
                    toast.error(`${ErrorMessages['addLog']} ${errorMessage}`, toastOpt);
            } else {
                if (jobLogToEdit)
                    toast.error(`${ErrorMessages['editLog']} ${error.message ?? error}`, toastOpt);


                else
                    toast.error(`${ErrorMessages['addLog']} ${error.message ?? error}`, toastOpt);

            }
        },
        onCompleted: () => {
            if (jobLogToEdit) toast.success(Messages['editLog'], toastOpt);
            else toast.success(Messages['addLog'], toastOpt);
            setShowAddEditJobLogModal(false);
        },
        refetchQueries: [
            {
                query: GET_JOB_LOG_META_DATA,
                variables: {
                    jobId: jobId,
                },
            },
            {
                query: GET_JOB_LOGS,
                variables: {
                    input: {
                        jobId: jobId,
                        jobLogTypeId: jobLogTypeId,
                        jobLogId: jobLogId,
                        fromDate: fromDate,
                        toDate: toDate,
                        pageNum: pageNum,
                        tzinfo: new Date()
                            .toString()
                            .split('(')[1]
                            .replace(')', ''),
                    },
                },
            },
        ],
    });

    const handleOnSave = async (
        jobLogId,
        jobLogTypeId,
        jobLogIssueId,
        startDate,
        endDate,
        estimatedDowntime,
        jobStageId,
        loadId,
        notes,
        locationLofa,
        amount,
        rootCauseId,
        correctiveAction,
    ) => {
        await addEditJobLog({
            variables: {
                input: {
                    jobLogId: jobLogId,
                    jobLogIssueId: jobLogIssueId,
                    jobLogTypeId: jobLogTypeId,
                    jobId: jobId,
                    startDate: startDate,
                    endDate: endDate,
                    estimatedDowntime: estimatedDowntime,
                    jobStageId: jobStageId,
                    loadId: loadId,
                    notes: notes,
                    locationLofa: locationLofa,
                    amount: amount,
                    rootCauseId: rootCauseId,
                    correctiveAction: correctiveAction,
                },
            },
        });
    };

    const handleOnClearFromDate = () => {
        setClearFromDate(true);
        setClearToDate(true);

        setTempDate('');
        setDateError('');
        setToDate(
            `${today.getFullYear()}-${today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1}-${today.getDate() < 10 ? `0${today.getDate()}` : today.getDate()
            }`,
        );

        const tempFromDate = new Date();
        tempFromDate.setDate(today.getDate() - 13);
        setFromDate(
            `${tempFromDate.getFullYear()}-${tempFromDate.getMonth() + 1 < 10 ? `0${tempFromDate.getMonth() + 1}` : tempFromDate.getMonth() + 1
            }-${tempFromDate.getDate() < 10 ? `0${tempFromDate.getDate()}` : tempFromDate.getDate()}`,
        );

        document.getElementById('JobLogs-DateFilter-Container')?.click();
    };

    const onFromDateChange = value => {
        setClearFromDate(false);
        const newFromDate = new Date(value);
        setTempDate(newFromDate);

        setOpenFromCalender(false);
        setOpenToCalender(true);
    };

    const onToDateChange = value => {
        setClearToDate(false);
        setPageNum(1);
        const newToDate = new Date(value);

        if (tempDate && tempDate <= newToDate) {
            setOpenFromCalender(true);
            setOpenToCalender(false);
            document.getElementById('JobLogs-DateFilter-Container')?.click();

            setFromDate(
                `${tempDate.getFullYear()}-${tempDate.getMonth() + 1 < 10 ? `0${tempDate.getMonth() + 1}` : tempDate.getMonth() + 1
                }-${tempDate.getDate() < 10 ? `0${tempDate.getDate()}` : tempDate.getDate()}`,
            );

            setToDate(
                `${newToDate.getFullYear()}-${newToDate.getMonth() + 1 < 10 ? `0${newToDate.getMonth() + 1}` : newToDate.getMonth() + 1
                }-${newToDate.getDate() < 10 ? `0${newToDate.getDate()}` : newToDate.getDate()}`,
            );
            setDateError('');
        } else {
            setOpenToCalender(false);
            setDateError('To date can not be lower than from date.');
        }
    };

    const onChangeFilter = (jobLogTypeId, jobLogType) => {
        setJobLogType(jobLogType);
        setJobLogTypeId(jobLogTypeId);
        setPageNum(1);
    };

    const onClickDownload = () => {
        setIsDownload(true);
        downloadJobLogs({
            variables: {
                input: {
                    jobId: jobId,
                    jobLogTypeId: jobLogTypeId,
                    jobLogId: jobLogId,
                    fromDate: fromDate,
                    toDate: toDate,
                    pageNum: -1,
                    tzinfo: new Date()
                        .toString()
                        .split('(')[1]
                        .replace(')', ''),
                    key: Math.floor(Math.random() * (100 + 1)),
                },
            },
        });
    };

    const onClickAdd = () => {
        setShowAddEditJobLogModal(true);
        setJobLogToEdit(undefined);
    };

    const onClickEdit = jobLogData => {
        if (jobLogData.jobLogTypeId === 5) {
            if (jobLogData.jobLogIssue == 'Start Stage') {
                setIsStartStage(true);
            } else {
                setIsStartStage(false);
            }
            setJobLogToEdit(jobLogData);
            setShowJobLogStageModal(true);
        } else {
            setJobLogToEdit(jobLogData);
            setShowAddEditJobLogModal(true);
        }
    };

    const onClickCancel = () => {
        setShowJobLogStageModal(false);
        setShowAddEditJobLogModal(false);
        setJobLogToEdit(undefined);
    };

    return (
        <div className="JobLogs-Details-Container">
            <ToastContainer />
            <div className="JobLogs-Filter-Container">
                <div className="JobLogs-Details-Filter-Container">
                    <Dropdown>
                        <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                            <span>{jobLogType}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='Job-log-type-dropdown'>
                            <Dropdown.Item onClick={() => onChangeFilter(-1, 'Job Log Type')}>All</Dropdown.Item>
                            {jobLogsTypesData.map((jobLogsFilter, index) => (
                                <Dropdown.Item
                                    key={index}
                                    onClick={() => onChangeFilter(jobLogsFilter.id, jobLogsFilter.descrip)}
                                >
                                    {jobLogsFilter.descrip}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown>
                        <Dropdown.Toggle variant="outline-dark" id="JobLogs-DateFilter-Container">
                            <span className="JobLogs-DateFilter-Text">
                                {fromDate} To {toDate}
                            </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="JobLogs-DateFilter-Dropdown-Container">
                            <div className="JobLogs-Clear-Dates" onClick={handleOnClearFromDate}>
                                Clear Dates
                            </div>
                            <div className="JobLogs-DateFilter-Container">
                                <div id="JobLogs-From-Calender">
                                    <DateTimePicker
                                        dateOnly
                                        label="FROM date"
                                        value={clearFromDate ? '' : fromDate}
                                        // open={openFromCalender}
                                        error={''}
                                        onChange={(value: any) => {
                                            onFromDateChange(value);
                                        }}
                                    />
                                </div>
                                <span className="DatePickerFilterItem-Divider">-</span>
                                <div id="JobLogs-To-Calender">
                                    <DateTimePicker
                                        dateOnly
                                        label="TO date"
                                        value={clearToDate ? '' : toDate}
                                        // open={openToCalender}
                                        error={dateError}
                                        onChange={(value: any) => {
                                            onToDateChange(value);
                                        }}
                                    />
                                </div>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="JobLogs-Details-Buttons">
                    {isAddJobLogsEnabled && (
                        <span className="JobLogs-Button-Text" onClick={onClickAdd}>
                            <i className="material-icons JobLogs-Button-Icon">add_circle</i>
                            Add Job Log
                        </span>
                    )}

                    <span className="JobLogs-Button-Text JobLogs-Download-Button" onClick={onClickDownload}>
                        {jobLogsForDownloadLoading && <Loading />}
                        <i className="material-icons JobLogs-Button-Icon">get_app</i>
                        Download CSV
                    </span>
                </div>
            </div>

            {jobLogsLoading ? (
                <div className="JobLogs-Loading">
                    <Loading />
                </div>
            ) : jobLogsError ? (
                <Error error={jobLogsError} />
            ) : jobLogsDetails.length === 0 && pageNum === 1 ? (
                <div className="JobLogs-NoResult-Container">
                    <div className="NoResult-Second-Title-Primary">No Job Logs available</div>
                </div>
            ) : (
                <div className="JobLogs-Details">
                    <div className="JobLogs-Details-Grid">
                        {(stopJobLogLoading || deleteJobLogLoading) && (
                            <div className="JobLogs-Loading">
                                <Loading />
                            </div>
                        )}
                        <Table bordered className="tabletest JobLogs-Details-Table">
                            <thead className="JobLogs-Details-Header">
                                <tr>
                                    <th>ID</th>
                                    <th>Log Type</th>
                                    <th>Issue</th>
                                    <th>Notes</th>
                                    <th>Started On</th>
                                    <th>Ended On</th>
                                    <th>Duration</th>
                                    <th colSpan={2} className="JobLogs-Details-Action-Header"></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: teams">
                                {jobLogsDetails &&
                                    jobLogsDetails.map((jobLogsData, index) => (
                                        <JobLogDetailsItem
                                            key={index}
                                            jobLogsData={jobLogsData}
                                            handleOnStopLog={handleOnStopLog}
                                            handleOnDeleteLog={handleOnDeleteLog}
                                            onClickEdit={() => onClickEdit(jobLogsData)}
                                        />
                                    ))}
                            </tbody>
                        </Table>
                    </div>

                    <div className="JobLogs-Prev-Next-Container">
                        <div
                            className={`JobLogs-Prev ${(jobLogsLoading || pageNum === 1) &&
                                'JobLogs-Prev-Next-Disabled'}`}
                            onClick={() => !jobLogsLoading && pageNum !== 1 && setPageNum(pageNum - 1)}
                        >
                            <i className="material-icons">chevron_left</i>
                            Previous
                        </div>
                        <div
                            className={`JobLogs-Prev ${(jobLogsLoading || isLastItem) && 'JobLogs-Prev-Next-Disabled'}`}
                            onClick={() => !jobLogsLoading && !isLastItem && setPageNum(pageNum + 1)}
                        >
                            Next
                            <i className="material-icons">chevron_right</i>
                        </div>
                    </div>
                </div>
            )}

            {showAddEditJobLogModal && (
                <AddEditJobLogModal
                    jobId={jobId}
                    jobLogsData={jobLogToEdit}
                    jobLogsTypesData={jobLogsTypesData}
                    jobLogIssues={jobLogsIssuesData}
                    jobLogRootCauses={jobLogsRootCausesData}
                    jobLogLocationLofa={jobLogsLocationLofaData}
                    showAddEditJobLogModal={showAddEditJobLogModal}
                    mutationLoading={addEditJobLogLoading}
                    errorMessage={modalError}
                    onClickCancel={onClickCancel}
                    onClickSave={handleOnSave}
                />
            )}

            {showJobLogStageModal && (
                <JobLogStageModal
                    jobId={jobId}
                    showModal={showJobLogStageModal}
                    jobLogsData={jobLogToEdit}
                    onClickCancel={onClickCancel}
                    isStartStage={isStartStage}
                />
            )}
        </div>
    );
};

export default JobLogDetails;
